import { ApiProductclass } from '@/models/api/productclass'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ContactLensFKU from '@/models/item/fku/contact-lens'
import ContactLensRoot from '@/models/item/root/contact-lens'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import { flatMap } from 'lodash'

interface Root {
  name: string
  brand: string
  category: string[]
}
interface Fku {
  id: string
  color: string
  sku: Sku[]
}
interface Sku {
  id: string
  // ショートIDとロングIDの併用については @link https://github.com/my-color/front/pull/6453#issuecomment-1127426043
  short_id: string
  sku_number: string
  price: number
}

export function rootAdapterFromApiProductclass(productclass: ApiProductclass): Root {
  return {
    name: productclass.name,
    brand: productclass.belongingBrand ? productclass.belongingBrand.englishName : '',
    // string[]型をとっているがproductclass.categoriesの長さは0か1なので複数個になることはないことに注意
    category: productclass.categories.map(c => c.pathname),
  }
}
export function fkuAdapterFromApiProductclass(productclass: ApiProductclass): Fku {
  return {
    id: productclass.id,
    color: productclass.color ? productclass.color.label : '',
    sku: productclass.parts.map(part => ({
      id: part.id,
      short_id: part.shortId,
      sku_number: part.skuNumber,
      /**
       * TODO: 有料会員機能がONの場合は有料会員価格を当てること
       */
      price: part.price.discounted || part.price.regular,
    })),
  }
}
export function rootAdapterFromContactLensRoot(contactLensRoot: ContactLensRoot): Root {
  return {
    name: contactLensRoot.name,
    brand: contactLensRoot.brandEnglishName,
    category: contactLensRoot.categoryPathnames,
  }
}
/**
 * behaviorはContactLensSkuのgetStockStatusが依存しているためなのでここでは本来不要…
 */
export function fkuAdapterFromContactLensFku(contactLensFku: ContactLensFKU, behavior: BehaviorConfig): Fku {
  return {
    id: contactLensFku.id,
    color: contactLensFku.color ? contactLensFku.color.label : '',
    sku: contactLensFku.skus(behavior).map(sku => ({
      id: sku.id.long,
      short_id: sku.id.short,
      sku_number: sku.skuNumber,
      price: sku.price,
    })),
  }
}

// アパレル・カラコン両方のテンプレートで共通で利用する
export function publishEventForThirdParty(
  root: Root,
  fkuList: Fku[]
): void {
  EventBusForThirdParty.getInstance().publish('product-detail-view', {
    root,
    fku: fkuList.map(fku => ({
      id: fku.id,
      color: fku.color,
      price: fku.sku.reduce(
        (prev, sku) => ({
          min: prev.min === 0 ? sku.price : Math.min(prev.min, sku.price),
          max: Math.max(prev.max, sku.price),
        }),
        { min: 0, max: 0 }
      ),
    })),
    sku: flatMap(fkuList, fku => fku.sku),
  })
}
